import { BaseEntity } from "../common/baseEntity";
import { AmazonProduct } from "./AmazonProduct";

export class AmazonStoreCredentials extends BaseEntity<string> {
    public StoreName: string;
    public MwsAuthToken: string;
    public SellerId: string;
    public MarketplaceId: string;
    public Products: Array<AmazonProduct>;
    public TotalCount: number;
}


// WEBPACK FOOTER //
// ./app/objects/amazon/AmazonStoreCredentials.ts